export default function isTouch() {
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

  document.documentElement.classList.toggle('supports-touch', isTouch);

  return isTouch;
}

isTouch();
